module.exports = __webpack_public_path__ + "static/media/visual_perception_iconf75a618e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/visual_perception_icon.svg
// module id = 1345
// module chunks = 0